import React, { useEffect, useState } from "react";
import { UserService } from "../../services/userService";
import { Row, Col, Label, Input } from "reactstrap";
import { useParams, useHistory } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import toastr, { success } from 'toastr'
import { deleteCart, deleteStoreFromCart } from '../../store/auth/cart/actions'
import { useDispatch, useSelector } from 'react-redux'

export default function Cash(props) {
    const user = useSelector(x => x.Login.user);
    const userService = new UserService();
    // props.orderId contiene el ID que antes venía de params.id
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch()
    console.log(props.price)
    console.log("----> pago efectivo",props.orderId)
const enviar = async () => {
    try {
        const getPublicIp = async () => {
            try {
                const res = await fetch('https://api.ipify.org?format=json');
                const data = await res.json();
                return data.ip;
            } catch (err) {
                console.error('Error al obtener la IP pública:', err);
                return '0.0.0.0'; // valor por defecto si falla
            }
        };

        const ip = await getPublicIp();
        const response = await userService.cashPayment(parseInt(props.orderId), ip);

        console.log("respuesta pago efectivo", response);

        if (response.success || response.codSalida === "APPROVED") {
            dispatch(deleteCart());
            toastr.success("SU ORDEN SE PAGARÁ EN EFECTIVO");
            history.push({
                pathname: `/PaymentConfirmationPSE/${props.orderId}`
            });
        } else {
            toastr.error(response.message || 'Error en el pago');
        }
    } catch (err) {
        console.error('Error durante el pago en efectivo:', err);
        toastr.error('No se pudo completar el pago en efectivo.');
    }
};


    return (

        <React.Fragment>
            {
                props.price.map((order, key) => {
                    return <Row key={key}>
                        <Col>
                            <span>TOTAL</span>
                            <h3>{order.totalMoneda}</h3>
                            <span>Costo de domicilio:  {order.totalEnvioMoneda || 5000}</span><br></br>
                            <span>Subtotal:  {order.subTotalMoneda}</span>
                            <hr></hr>
                            <span>DIRECCIÓN DE ENTREGA</span><br></br>
                            <strong>{order.direccionPersona.nomenclatura}</strong>
                            <hr></hr>
                        </Col>
                    </Row>
                })
            }
            <Row>
                <button className="boton3-fanero btn-block" onClick={enviar}>Confirmar</button>{'   '}
            </Row>
        </React.Fragment>
    )
}
